import { faCircleExclamation, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Rating, Typography, Button, Avatar, Grid, IconButton, Divider, Pagination, Menu, MenuItem, Stack, Dialog, DialogContent } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Image from "next/image";
import CommentReport from './commentReport';
import { GetReviewProduct } from '@/api/review/review';
import Cookies from 'universal-cookie';
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import 'dayjs/locale/th';
import { useRouter } from 'next/router';
import CloseIcon from '@mui/icons-material/Close';
dayjs.extend(buddhistEra);
import { checkLoginStatus } from '@/utils/authen';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
export default function StarRatingreview({ storeId, type, dataStoreInfo, ProductIdReview, dataProduct }: any) {

    const cookie = new Cookies();
    const authToken = cookie.get("token");
    const memberId = cookie.get("memberId");
    const { isLoggedIn } = checkLoginStatus();
    const token = authToken !== "" ? authToken : null as any;
    const router = useRouter();
    const [value, setValue] = React.useState<number | null>(0);
    const [activeButton, setActiveButton] = useState("all");
    const [dataStoreReview, setDataStoreReview] = useState([])
    const [reviewId, setReviewId] = useState([])
    const [productId, setProductId] = useState([])
    const [open, setopen] = useState(false)
    const [filter, setfilter] = useState()
    const [filterscore, setfilterscore] = useState()
    const [page, setPage] = useState(1);
    const [itemRatingSummary, setItemRatingSummary] = useState<any>([])
    const [count, setCount] = useState<any>([])
    const store_id = storeId
    const order_id = ""
    const product_id = ProductIdReview
    const review_id = ""
    const limit = type === 'store' ? 10 : 5;
    const offset = (page - 1) * limit;
    const defaultImage = "/assets/images/logo/logomaboom.png"
    const [nextAddToCartFullPath, setNextAddToCartFullPath] = useState<any>('');
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedButton, setSelectedButton] = useState("5stars");
    const [selectedMedia, setSelectedMedia] = useState<string | null>(null); 
    const [isVideo, setIsVideo] = useState<boolean>(false);
    const [openimage, setOpenImage] = useState(false);


    const GetReview = async (token: string, type: any, store_id: any, order_id: any, product_id: any, review_id: any, limit: any, offset: any, filter: any, filterscore: any) => {
        const response = await GetReviewProduct(token, type, store_id, order_id, product_id, review_id, limit, offset, filter, filterscore)
        setCount(response?.page)
        setDataStoreReview(response?.data)
        setItemRatingSummary(response?.item_rating_summary)
    }

    const buttons = [
        { label: `ทั้งหมด (${itemRatingSummary?.rating_total || 0})`, id: "all", filter: "", store_score: "" },
        { label: `รีวิวที่มีรูปภาพ (${itemRatingSummary?.rcount_with_image || 0})`, id: "withImage", filter: "1", store_score: "" },
        { label: `5 ดาว (${itemRatingSummary?.rating_count?.[0] || 0})`, id: "5stars", filter: "", store_score: "5" },
        { label: `4 ดาว (${itemRatingSummary?.rating_count?.[1] || 0})`, id: "4stars", filter: "", store_score: "4" },
        { label: `3 ดาว (${itemRatingSummary?.rating_count?.[2] || 0})`, id: "3stars", filter: "", store_score: "3" },
        { label: `2 ดาว (${itemRatingSummary?.rating_count?.[3] || 0})`, id: "2stars", filter: "", store_score: "2" },
        { label: `1 ดาว (${itemRatingSummary?.rating_count?.[4] || 0})`, id: "1star", filter: "", store_score: "1" },
    ];
    const buttonsSelect = [
        { label: `5 ดาว (${itemRatingSummary?.rating_count?.[0] || 0})`, id: "5stars", filter: "", store_score: "5" },
        { label: `4 ดาว (${itemRatingSummary?.rating_count?.[1] || 0})`, id: "4stars", filter: "", store_score: "4" },
        { label: `3 ดาว (${itemRatingSummary?.rating_count?.[2] || 0})`, id: "3stars", filter: "", store_score: "3" },
        { label: `2 ดาว (${itemRatingSummary?.rating_count?.[3] || 0})`, id: "2stars", filter: "", store_score: "2" },
        { label: `1 ดาว (${itemRatingSummary?.rating_count?.[4] || 0})`, id: "1star", filter: "", store_score: "1" },
    ];
    const buttonsSelecttwo = [
        { label: `ทั้งหมด (${itemRatingSummary?.rating_total || 0})`, id: "all", filter: "", store_score: "" },
        { label: `รูปภาพ (${itemRatingSummary?.rcount_with_image || 0})`, id: "withImage", filter: "1", store_score: "" },
    ];


    const handleopenreport = (reviewId: any, productId: any) => {
        if (!isLoggedIn) {
            if (nextAddToCartFullPath) {
                router.push(`/account/signin?next=${nextAddToCartFullPath}`);
            }

        } else {
            setReviewId(reviewId)
            setopen(true)
            setProductId(productId)
        }


    }

    const handleButtonClick = (button: any) => {
        setActiveButton(button.id);
        const filter = button.filter;
        setfilter(filter);
        const filterscore = button.store_score;
        setfilterscore(filterscore);
        setPage(1);
        GetReview(token, type, store_id, order_id, product_id, review_id, limit, offset, filter, filterscore);
    };

    const handleButtonClickSelect = (button: any) => {
        setActiveButton(button.id);
        const filter = button.filter;
        setfilter(filter);
        const filterscore = button.store_score;
        setfilterscore(filterscore);
        setPage(1);
        setAnchorEl(button);
        GetReview(token, type, store_id, order_id, product_id, review_id, limit, offset, filter, filterscore);
    };

    const handleMenuItemClick = (button: any) => {
        setSelectedButton(button.id);
        setActiveButton(button.id);
        const filter = button.filter;
        setfilter(filter);
        const filterscore = button.store_score;
        setfilterscore(filterscore);
        setPage(1);
        setAnchorEl(button);
        handleButtonClickSelect(button);
        GetReview(token, type, store_id, order_id, product_id, review_id, limit, offset, filter, filterscore);


    };


    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        // GetReview(token, type, store_id, order_id, product_id, review_id, limit, offset, filter, filterscore);
    };
    const handleMediaClick = (mediaUrl: string) => {
        setSelectedMedia(mediaUrl);
        setIsVideo(mediaUrl.endsWith('.mp4'));
        setOpenImage(true); 
    };


    const handleclickProduct = (slug: any, storeId:any , productId:any) => {
        router.push(`/product/${slug}?store=${storeId}&id=${productId}`)
    }



    useEffect(() => {
        GetReview(token, type, store_id, order_id, product_id, review_id, limit, offset, filter, filterscore)
    }, [page, product_id])

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const protocol = window.location.protocol;
            const host = window.location.host;
            const fullPath = encodeURIComponent(`${protocol}//${host}${router.asPath}`);
            setNextAddToCartFullPath(fullPath);
        }
    }, [router]);

    return (
        <>
            <Typography className="fontBold" sx={{ fontSize: "24px" }}>
                {type === "product" && "คะแนนสินค้า/บริการ"}
                {type === "store" && "คะแนนร้านค้า"}
            </Typography>

            <Box
                sx={{
                    display: "flex",
                    alignItems: "baseline",
                    width: "100%",
                    padding: "10px 16px 0px 0px",
                }}
            >
                <Typography
                    className="fontBold"
                    sx={{
                        color: "#292929",
                        fontSize: "36px",
                    }}
                >
                    {/* <pre>{JSON.stringify(dataStoreInfo, null, 2)}</pre> */}
                    {/* {dataStoreInfo === "product"
                        ? dataProduct
                        : type === "store"
                            ? dataStoreInfo
                            : 0} */}
                    {dataStoreInfo === null ? 0 : type === "product" ? dataProduct : type === "store" ? dataStoreInfo : 0}
                    /
                </Typography>


                <Typography
                    sx={{
                        fontSize: "20px",
                        color: "#717275",
                        lineHeight: "36px",
                    }}
                >
                    5
                </Typography>
                <Rating
                    name="simple-controlled"
                    value={type === "product" ? dataProduct : type === "store" ? dataStoreInfo : 0}
                    precision={0.5}
                    onChange={(event: any, newValue: any) => {
                        setValue(newValue);
                    }}
                    style={{
                        left: "5px",
                        marginTop: "2px",
                        lineHeight: "36px",
                        top: "4px"
                    }}
                    readOnly
                />
            </Box>
            <Box
                sx={{

                    gap: "8px",
                    flexWrap: "wrap",
                    display: { xs: "none", md: "flex" }
                }}
            >
                {buttons.map((button: any) => (
                    <Button
                        key={button.id}
                        variant="outlined"
                        onClick={() => handleButtonClick(button)}
                        className={activeButton === button.id ? "btn-1" : "btn-17"}
                    >
                        {button.label}
                    </Button>
                ))}
            </Box>
            <Stack direction="row" sx={{ flexWrap: "wrap", gap: "8px", justifyContent: "space-between", width: "100%", display: { xs: "flex", md: "none" } }}>
                <Box
                    sx={{

                        gap: "8px",
                        flexWrap: "wrap",
                        display: "flex"
                    }}
                >
                    {buttonsSelecttwo.map((button: any) => (
                        <Button
                            key={button.id}
                            variant="outlined"
                            onClick={() => handleButtonClick(button)}
                            className={activeButton === button.id ? "btn-1" : "btn-17"}
                        >
                            {button.label}
                        </Button>
                    ))}
                    <Button
                        variant="outlined"
                        className={activeButton === selectedButton ? "btn-1" : "btn-17"}
                        // onClick={(event) => {
                        //     setAnchorEl(event.currentTarget);
                        //     const currentButton = buttons.find((b) => b.id === selectedButton);
                        //     if (currentButton) {
                        //         handleButtonClickSelect(currentButton);
                        //     }
                        // }}
                        onClick={(event) => {
                            setAnchorEl(event.currentTarget); // Set the anchorEl to the button clicked
                        }}
                        sx={{ width: "100px", justifyContent: "space-between" }}
                    >
                        {buttonsSelect.find((b) => b.id === selectedButton)?.label} 
                        <ArrowDropDownIcon sx={{ position: "absolute", right: "0" }}/>
                    </Button>


                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        anchorOrigin={{
                            vertical: 'bottom', // Position menu below the button
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        {buttonsSelect.map((button) => (
                            <MenuItem
                                key={button.id}
                                onClick={() => (handleMenuItemClick(button), setAnchorEl(null))}
                                selected={selectedButton === button.id}
                            >
                                {button.label}
                            </MenuItem>
                        ))}
                    </Menu>
                    
                </Box>

            </Stack>

            {dataStoreReview?.length === 0 ? (
                <>
                    <Grid container spacing={2}>
                        <Grid xs={12} sx={{ py: 20 }} display="flex" justifyContent="center">
                            <Typography
                                className="fontBold"
                                sx={{
                                    color: "#717275",
                                    fontSize: "20px",
                                    textAlign: "center"
                                }}
                            >
                                ยังไม่มีคะแนนรีวิว
                            </Typography>
                        </Grid>
                    </Grid>

                </>
            ) : (
                <>
                    {dataStoreReview?.map((data: any, idx: number) => {
                        const formattedDate = dayjs(data.review_at)
                            .locale("th")
                            .format("DD/MM/YYYY HH:mm น.");

                        return (
                            <Box key={idx} sx={{ border: "1px solid #DEE2E6", borderRadius: "8px", mt: "15px" }}>


                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        padding: "10px 16px 10px 10px",
                                        cursor: type === "store" ? "pointer" : "default",
                                    }}
                                    onClick={
                                        type === "store"
                                            ? () => handleclickProduct(data?.product_review?.product_slug, storeId, data.product_id)
                                            : undefined
                                    }
                                >
                                    <Image
                                        src={data?.product_review?.product_image?.[0]?.product_thumbnail_image_url}
                                        alt="Product Thumbnail"
                                        width={40}
                                        height={40}
                                        layout="fixed"
                                        style={{
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            marginLeft: "10px",
                                        }}
                                    >
                                        <Typography className="fontBold" sx={{ fontSize: "14px", color: "#000000" }}>
                                            {data?.product_review?.product_title}
                                        </Typography>
                                        {data?.product_review?.product_option && (
                                            <Typography sx={{ fontSize: "12px", color: "#717275" }}>
                                                {data?.product_review?.product_option?.product_option_title} :{" "}
                                                {data?.product_review?.product_option?.product_option_name}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>

                                <Divider />

                                {/* User Information */}
                                <Box sx={{ display: "flex", alignItems: "center", padding: "20px 16px 10px 10px" }}>
                                    <Avatar alt="User Avatar" src={data?.profileImage || defaultImage} sx={{ width: 25, height: 25 }} />
                                    <Typography className="fontBold" sx={{ ml: 1, color: "#292929", fontSize: "16px" }}>
                                        {/*ชื่อที่แสดงผู้ใช้งาน */}
                                        {data?.username}
                                    </Typography>
                                </Box>

                                {/* Review Content */}
                                <Box sx={{ padding: "0px 10px 10px 40px" }}>
                                    <Rating
                                        name="simple-controlled"
                                        value={data?.review_score}
                                        size="small"
                                        onChange={(event, newValue) => setValue(newValue)}
                                        readOnly
                                    />
                                    <Typography sx={{ fontSize: "16px", color: "#292929", p: "0px 10px 10px 0px" }}>{data?.review_detail}</Typography>
                                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                        {data?.review_image?.length > 0 &&
                                            data.review_image.map((media: any, index: number) => {
                                                const isVideo = media.image_url.endsWith('.mp4');

                                                return isVideo ? (
                                                    <>
                                                        <div
                                                            key={index}
                                                            style={{
                                                                position: 'relative',
                                                                width: '60px',
                                                                height: '60px',
                                                                borderRadius: '10px',
                                                                overflow: 'hidden',
                                                                marginLeft: '8px',
                                                            }}
                                                        >

                                                            <video

                                                                playsInline
                                                                autoPlay
                                                                muted
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover',
                                                                    borderRadius: '10px',
                                                                }}
                                                                onClick={() => handleMediaClick(media.image_url)}
                                                            >
                                                                <source src={media.image_url} type="video/mp4" />
                                                            </video>


                                                            <FontAwesomeIcon
                                                                icon={faPlay}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)',
                                                                    fontSize: '20px',
                                                                    color: 'white',
                                                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                                    borderRadius: '50%',
                                                                    padding: '5px',
                                                                    pointerEvents: 'none',
                                                                    width: '.7em', height: '.7em'
                                                                }}
                                                            />
                                                        </div>

                                                    </>
                                                ) : (
                                                    <Image
                                                        key={index}
                                                        src={media.image_url}
                                                        alt={`Product Media ${index}`}
                                                        width={60}
                                                        height={60}
                                                        layout="fixed"
                                                        style={{
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                        }}
                                                        onClick={() => handleMediaClick(media.image_url)}
                                                    />
                                                );
                                            })}
                                    </div>
                                </Box>

                                {/* Footer Section */}
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Typography sx={{ fontSize: "10px", pb: "20px", ml: "40px", color: "#717275" }}>
                                        {formattedDate}
                                    </Typography>

                                    {data?.allow_report_status === false ? (
                                        <>
                                            {/* <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    p: "0px 10px 20px 10px",
                                                    margin: "0px 40px 0px 40px",
                                                    whiteSpace: "nowrap"
                                                }}

                                            >
                                                <FontAwesomeIcon icon={faCircleCheck} fontSize={12} style={{ color: "#717275" }} />
                                                <Typography sx={{ fontSize: "12px", ml: "4px", color: "#717275" }}>
                                                    รายงานความคิดเห็นแล้ว
                                                </Typography>
                                            </Box> */}
                                        </>

                                    ) : (
                                        
                                        <Box
                                            sx={{
                                                // display: "flex",
                                                alignItems: "center",
                                                p: "0px 10px 20px 10px",
                                                margin: "0px 40px 0px 40px",
                                                cursor: "pointer",
                                                display: data.member_id == memberId? "none":"flex"
                                            }}
                                            onClick={() => handleopenreport(data?.review_id, data?.product_id)}
                                        >
                                            <FontAwesomeIcon icon={faCircleExclamation} fontSize={12} style={{ color: "#717275" }} />
                                            <Typography sx={{ fontSize: "12px", ml: "4px", color: "#717275" }}>
                                                รายงาน
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>

                             
                                {
                                    data?.store_reply_detail && (
                                        <Box
                                            sx={{
                                                padding: "10px",
                                                border: "1px solid #DEE2E6",
                                                borderRadius: "4px",
                                                bgcolor: "#F5F6F8",
                                                margin: "0px 40px 20px 40px",
                                            }}
                                        >
                                            <Typography className="fontBold" sx={{ color: "#292929", fontSize: "16px" }}>
                                                การตอบกลับจากผู้ขาย
                                            </Typography>
                                            <Typography sx={{ fontSize: "14px", color: "#292929" }}>
                                                {data?.store_reply_detail}
                                            </Typography>
                                        </Box>
                                    )
                                }
                            </Box>
                        );
                    })}
                </>
            )}
            <CommentReport open={open} setopen={setopen} store_id={store_id} reviewId={reviewId} productId={productId}></CommentReport>
            {
                dataStoreReview?.length === 0 ? (
                    <></>

                ) : (
                    <>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', mt: "10px" }}>
                            <Pagination
                                count={count}
                                page={page}
                                variant="outlined"
                                color="primary"
                                onChange={handlePageChange}
                                shape="rounded"
                            />
                        </Box>
                    </>
                )
            }
         
            <Dialog
                open={openimage}
                onClose={() => setOpenImage(false)}
                maxWidth="sm"
                fullWidth
               
            >
                <DialogContent
                    style={{
                        position: 'relative',
                        padding: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%', 
                    }}
                >
                  
                    <IconButton
                        onClick={() => setOpenImage(false)}
                        style={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            zIndex: 1,
                            background: 'rgba(0, 0, 0, 0.5)',
                            color: '#fff',
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                 
                    {isVideo ? (
                        <video
                            controls
                            playsInline
                            autoPlay
                            muted
                            style={{
                                width: '100%', 
                                height: '100%', 
                                objectFit: 'contain', 
                            }}
                        >
                            <source src={selectedMedia || ''} type="video/mp4" />
                        </video>
                    ) : (
                        <Image
                            src={selectedMedia || ''}
                            alt="Selected Media"
                            width={0}
                            height={0}
                            layout="responsive"
                            style={{
                                objectFit: 'contain', 
                                width: '100%', 
                                height: '100%', 
                            }}
                        />
                    )}
                </DialogContent>
            </Dialog>

          


        </>
    )
}